module.exports = __webpack_public_path__ + "img/1.c83bc1a9.webp";